module.exports = __webpack_public_path__ + "img/UTANAS-1.6fb032fd.jpg";